"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.object.assign.js");

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgRocheLogo = function SvgRocheLogo(props) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], _extends({}, props, {
    viewBox: "0 0 55 30"
  }), /*#__PURE__*/_react["default"].createElement("style", null, '.roche_logo_svg__st0{fill:#06c}'), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M37.6 11c-.3-.3-.9-.4-1.4-.4-.6 0-1.1.2-1.5.5V7.5H33v11.7h1.8v-6.1c0-.4.4-.9 1-.9.3 0 .7.1.9.4.2.3.2.8.2 1.2v5.4h1.8v-5.4c0-1.6-.3-2.2-1.1-2.8M23.2 15v1.6c-.1.6-.3 1.3-1.1 1.3-.7 0-1-.7-1.1-1.3v-1.5-1.6c0-.6.3-1.3 1.1-1.3s1.1.6 1.1 1.3V15m1.8-1.4c-.3-2.5-1.7-3-2.8-3-1.6 0-2.7 1-2.8 3v2.8c.1 1.8 1.2 3 2.8 3 1.7 0 2.7-1.2 2.8-3V15v-1.4zM41.6 14v-.6c0-.7.4-1.3 1.1-1.3.8 0 1 .8 1.1 1.3v.6h-2.2m2.2 2.3v.3c0 .4-.2 1.3-1.1 1.3-.7 0-1-.7-1.1-1.3v-1.1h3.9v-.9-.9c-.1-.7-.3-1.6-.8-2.1-.5-.6-1.2-.9-2-.9-1.6 0-2.6 1-2.8 3v2.8c.1 1.8 1.2 3 2.8 3 1.6 0 2.7-1.1 2.8-3.1 0-.1-1.7-.1-1.7-.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.6 1.6h28.8l11 12.9-11 12.7H13.6l-11-12.7 11-12.9M43.1.1H12.9L.7 14.3l12.2 14.1h30.2l12.2-14.1L43.1.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14 9.1h.8c.9 0 1.4.5 1.4 1.3v.6c-.1.5-.3 1.4-1.3 1.4H14V9.1m4.2 9.4l-.2-2.9c-.1-1.3-.4-2-1.1-2.4.5-.3 1.1-1 1.1-2.5 0-2.3-1.4-3.1-3.1-3.1h-2.7v11.6H14v-5.3h1c.6 0 1.2.5 1.3 1.9l.2 2.7c0 .4.1.7.1.7h1.7s-.1-.3-.1-.7zM30.1 16.2v.3c0 .6-.3 1.3-1.1 1.3-.7 0-1-.7-1.1-1.3v-1.6-1.6c.1-.7.3-1.3 1.1-1.3.7 0 1.1.6 1.1 1.3v.5h1.8v-.3c-.2-2.4-1.7-3-2.8-3-1.6 0-2.7 1-2.8 3v2.8c.1 1.8 1.2 3 2.8 3 1.7 0 2.7-1 2.8-3v-.2h-1.8"
  }));
};

var _default = SvgRocheLogo;
exports["default"] = _default;